// extracted by mini-css-extract-plugin
module.exports = {"collections":"collections_collections__2_F4r","row":"collections_row__2_4fo","noprogress":"collections_noprogress__1lZRV"};